module.exports = __webpack_public_path__ + "img/JasonLuke.d8409afa.png";